<template>
  <div class="departments-fullscreen-content">
    <GMapMap
      ref="departmentsMap"
      :center="center"
      :zoom="zoom"
      :options="options"
      id="departments-map"
    >
      <GMapCluster
        :renderer="renderer"
      >
        <GMapMarker
          v-for="(marker, index) in markers"
          :key="index"
          :position="marker.position"
          :clickable="true"
          :icon='{
            url: versionAsset(marker.department.draft ? "/assets/shared/img/map-pin-icon-draft.svg" : "/assets/shared/img/map-pin-icon.svg"),
            scaledSize: {width: 55, height: 55}
          }'
          @click="openInfoWindow(marker.department)"
        >
        <GMapInfoWindow
          :opened="prevInfoWindow === marker.id"
          :closeclick="true"
          @closeclick="openInfoWindow(null)"
        >
          <div style="min-width: 320px; border-radius:10px;padding-top:14px;max-width:342px">
            <div class="flex gap-3 w-full justify-between right-space">
              <div class="flex gap-3 items-center">
                <img :src="versionAsset(marker.department.draft ? '/assets/shared/img/map-pin-icon-draft.svg' : '/assets/shared/img/map-pin-icon.svg')" :alt="marker.department.name" style="width:32px;height:auto;">
                <h2 style="color:#26272C;font-size:16px;font-weight:700;padding-bottom:4px;">
                  {{ marker.department.name }}
                  <span v-if="marker.department.draft" class="badge badge-soft bg-oscar-orange text-white">{{ $t('layout.location_coming_soon') }}</span>
                </h2>
              </div>
            </div>
            <p style="color:#545D78;font-size:14px;font-weight:500; padding-left:44px;"> {{ marker.department.addr }} </p>
            <div class="flex" :key="key" v-for="(value, key) in marker.department.open_hours" :class="{'days-border-top' : key === 'Monday', 'days-top' : key !== 'Monday'}">
              <p style="font-size:14px;color:#545D78;font-weight:400;width:50%;"> {{ key }} </p>
              <p style="font-size:14px;color:#545D78;font-weight:400;width:50%;" v-html="value" />
            </div>
            <div class="flex" style="border-bottom:1px solid #DDDFE4;padding-bottom:10px;margin-bottom:10px;padding-top:7px" >
              <p v-if="marker.department.key_box" style="font-size:11px;color:#545D78;font-weight:400;">{{ $t('layout.return_accepted_outside') }}</p>
            </div>
            <div class="flex gap-5" style="padding-bottom:10px;padding-top:7px">
              <div v-if="marker.department.carsCount && marker.department.cheapestCar" :style="{ 'font-size': '14px','color': '#545D78', 'font-weight': 300, 'width': marker.department.draft ? '100%' : '50%' }" v-html="$t('layout.location_vehicle_availability', {vehicleCount: marker.department.carsCount, price: marker.department.cheapestCar})"></div>
              <a v-if="!marker.department.draft" :href="marker.department.url" style="height:50px;border-radius:8px;font-size:14px;background-color: #26272C;color: white;font-weight:500;width:50%;display:flex;align-items:center;justify-content:center">
                {{ $t('subscription_booking_process.options.more_info') }}
              </a>
            </div>
          </div>
        </GMapInfoWindow>
        </GMapMarker>
      </GMapCluster>
    </GMapMap>
  </div>
</template>


<script>
export default {
  props: {
    backdrop: Boolean,
    focusedInput: String,
    departmentIds: {
      type: Array,
      required: false,
      default: []
    },
    latitude: {
      type: Number,
      required: false,
      default: 55.663450,
    },
    longitude: {
      type: Number,
      required: false,
      default: 12.551880,
    },
    zoom: {
      type: Number,
      required: false,
      default: 8,
    },
    departments: {
      type: Array,
      required: true
    },
  },
  data() {
    const options = {
      mapTypeControl: false,
      zoomControl: false,
      fullscreenControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
    };

    const renderer = {
      render: ({count, position}, stats) => {
        // change color if this cluster has more markers than the mean cluster
        const condition = count > Math.max(10, stats.clusters.markers.mean)
        const color = "#0374c2";
        const size = condition ? 70 : 55;
        // create svg url with fill color
        const svg = window.btoa(`
        <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <circle cx="120" cy="120"  r="70" />
        </svg>`);

        // create marker using svg icon
        return new google.maps.Marker({
          position,
          icon: {
            url: `data:image/svg+xml;base64,${svg}`,
            scaledSize: new google.maps.Size(size, size),
          },
          label: {
            text: String(count),
            color: "rgba(255,255,255,0.9)",
            fontSize: "14px",
            fontWeight: 'bold'
          },
          // adjust zIndex to be above other markers
          zIndex: 1000 + count,
        });
      }
    };

    return {
      center: {lat: parseFloat(this.latitude), lng: parseFloat(this.longitude)},
      options,
      markers: this.departments.filter(department => this.departmentIds.length ? this.departmentIds.includes(department.id) : true)
        .map((department) => ({
          position: { lat: parseFloat(department.lat), lng: parseFloat(department.lng) },
          department: department,
          id: department.id,
        })),
      renderer,
      departmentsMap: null,
      searchQuery: '',
      open: false,
      prevInfoWindow: null,
      googleMap: null,
    };
  },
  mounted() {
    this.$refs.departmentsMap.$mapPromise.then(googleMap => {
      this.googleMap = googleMap;
      googleMap.setOptions({ zoomControlOptions: { position: google.maps.ControlPosition.TOP_RIGHT } });
    });

    try {
      $(this.$el).height($(window).height() - $('header').outerHeight());

      setTimeout(() => {
        if (window.innerWidth > 768 && !this.open) {
          this.open = true;
        }
      }, 1500);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  },
  methods: {
    departmentClick(department) {
      this.openInfoWindow(department);
      this.open = false;
    },
    openInfoWindow(department) {
      if (this.prevInfoWindow) {
        this.prevInfoWindow = null;
      }

      if (!department) {
        return;
      }

      this.prevInfoWindow = department.id;
      if (this.googleMap && this.googleMap.getZoom() < 11) {
        this.googleMap.setZoom(11);
      }
      this.googleMap && this.googleMap.panTo(this.markers.filter(marker => marker.id === department.id)[0].position);
    }
  },
  computed: {
    groupedDepartments() {
      return this.departments
        .filter(department => department.name.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1)
        .filter(department => this.departmentIds.length ? this.departmentIds.includes(department.id) : true)
        .reduce((total, current) => {
          const firstLetter = current.name[0].toLowerCase();
          (total[firstLetter] = total[firstLetter] || []).push(current)
          return total;
        }, {});
    }
  },
  watch: {
    departmentIds() {
      this.markers = this.departments.filter(department => this.departmentIds.length ? this.departmentIds.includes(department.id) : true)
        .map((department) => ({
          position: { lat: parseFloat(department.lat), lng: parseFloat(department.lng) },
          department: department,
          id: department.id,
        }));
    }
  }
}

</script>

<style lang="scss">
/* ========= */
/*   MIXINS  */
/* ========= */

@mixin linear-gradient($direction, $color-stops...) {
  background: nth(nth($color-stops, 1), 1);
  background: -webkit-linear-gradient(legacy-direction($direction), $color-stops);
  background: linear-gradient($direction, $color-stops);
}

@mixin prefix($property, $value, $prefixes: ()) {
  @each $prefix in $prefixes {
    #{'-' + $prefix + '-' + $property}: $value;
  }

  // Output standard non-prefixed declaration
  #{$property}: $value;
}

@mixin transition($transition...) {
  -moz-transition: $transition;
  -o-transition: $transition;
  -webkit-transition: $transition;
  transition: $transition;
}

#departments-map, .vue-map-container {
  height: calc(100vh - 200px);
  @media (max-width: 991px) {
    height: calc(100vh - 100px);
  }
}

.custom-clustericon {
  background: var(--cluster-color);
  color: #FFF;
  border-radius: 100%;
  font-weight: bold;
  font-size: 15px;
  display: flex;
  align-items: center;
}

.custom-clustericon::before,
.custom-clustericon::after {
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  background: var(--cluster-color);
  opacity: 0.2;
  border-radius: 100%;
}

.custom-clustericon::before {
  padding: 7px;
}

.custom-clustericon::after {
  padding: 14px;
}

.custom-clustericon-1 {
  --cluster-color: #00A2D3;
}

.custom-clustericon-2 {
  --cluster-color: #FF9B00;
}

.custom-clustericon-3 {
  --cluster-color: #FF6969;
}

.departments-fullscreen-content {
  position: relative;

  .departments-map-sidebar {
    position: absolute;
    background: #fff;
    width: 400px;
    max-width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    box-shadow: 0px 0px 15px transparentize(#000000, .9);
    padding: 15px 15px;
    overflow-y: auto;
    @media(max-width: 768px) {
      width: 100%;
    }

    .title {
      font-size: 24px;
      font-weight: 700;
      margin-bottom: 15px;
      padding-left: 50px;
    }

    .search-wrapper {
      position: relative;
      margin-bottom: 20px;

      .search-icon {
        position: absolute;
        top: 14px;
        left: 15px;
        font-size: 22px;
        color: #bbb;
      }

      .clear-button {
        width: 32px;
        height: 32px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        border: none;
        position: absolute;
        top: 8px;
        left: 8px;
        color: #bbb;

        i {
          font-size: 22px;
        }

        &:hover {
          background: #eee;
          color: #161616;
        }
      }

      input {
        border: 1px solid #f2f2f2;
        background: #f2f2f2;
        border-radius: 6px;
        padding: 10px 20px;
        padding-left: 45px;
        font-size: 18px;
        font-weight: 600;
        width: 100%;
        @include transition(background .2s);

        &:focus {
          background: #fff;
          border-color: #eee;
          outline: none;
        }

        &::-webkit-input-placeholder { /* Edge */
          color: #bbb;
        }

        &:-ms-input-placeholder { /* Internet Explorer 10-11 */
          color: #bbb;
        }

        &::placeholder {
          color: #bbb;
        }
      }
    }

    .departments-list {
      .department {
        .group-letter-title {
          font-size: 18px;
          font-weight: 700;
          padding: 5px 0;
          border-bottom: 1px solid #eee;
          text-transform: uppercase;
        }

        .department-link {
          font-size: 14px;
          color: #aaa;
          font-weight: 500;
          display: block;
          padding: 4px 2px;
          border-radius: 3px;

          &:hover {
            background: #f2f2f2;
            color: #161616;
          }
        }
      }
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar {
      width: 12px;
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {

                background-color: #ddd;
                border-radius: 3px;
                border: 3px solid #fff;
            }
        }
        .departments-map-sidebar-toggle {
            width: 38px;
            height: 38px;
            font-size: 20px;
            border-radius: 50%;
            background: transparent;
            background: #ff7500;
            color: #fff;
            position: absolute;
            top: 13px;
            left: 15px;
            z-index: 10;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid transparent;
            @include transition(color .2s, background-color .2s);
            i {
                top: 0;
            }
            &.open {
                background: #fff;
                color: #161616;
                border-color: #ddd;
            }
            &:hover {
                background: darken(#ff7500, 5%);
                &.open {
                    background: #eee;}
    }
  }

  .sidebar-enter-active, .sidebar-leave-active {
    transition: opacity .2s, transform .2s ease-out;
  }

  .sidebar-enter, .sidebar-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
    @include prefix(transform, translate(-50%));
  }
}

.gm-style-iw-chr {
  position: absolute;
  right: 0;
}
.days-border-top {
  border-top:1px solid #DDDFE4;
  padding-top:10px;
  margin-top:10px;
}
.days-top{
  margin-top:7px;
}
@media(max-width: 768px) {
  div.gm-style-iw.gm-style-iw-c{
    max-width: 360px !important;
  }
}
</style>
